function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
import { RliPreHook } from '@rocketlane/rli-internal-sdk';
import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
import { ProjectEvents } from 'events/projects';
import { logger } from 'services';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import { getSimpleSearchFilterModule } from 'utils/simple-search-filter/module';
import { updateProjectsPartners } from 'utils/strategic-partner-utils';
const mapPhasesFieldAccessMetaInBase3 = (phases)=>phases === null || phases === void 0 ? void 0 : phases.map((phase)=>phase.fieldsAccessMeta != null ? {
            ...phase,
            fieldsAccessMetaInBase3: fieldAccessMetaToBase3(phase.fieldsAccessMeta)
        } : phase);
const mapPhaseFieldAccessMetaInBase3 = (phase)=>phase.fieldsAccessMeta != null ? {
        ...phase,
        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(phase.fieldsAccessMeta)
    } : phase;
/** Applies project-level fieldAccessMetaInBase3 and phase-level mapping for projectPhases, currentPhases, metrics.currentPhases. */ const withProjectMetaAndPhaseMeta = (project)=>{
    var _mapPhasesFieldAccessMetaInBase3, _mapPhasesFieldAccessMetaInBase31, _mapPhasesFieldAccessMetaInBase32;
    const withProjectMeta = project.fieldsAccessMeta != null ? {
        ...project,
        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(project.fieldsAccessMeta)
    } : project;
    return {
        ...withProjectMeta,
        projectPhases: (_mapPhasesFieldAccessMetaInBase3 = mapPhasesFieldAccessMetaInBase3(withProjectMeta.projectPhases)) !== null && _mapPhasesFieldAccessMetaInBase3 !== void 0 ? _mapPhasesFieldAccessMetaInBase3 : withProjectMeta.projectPhases,
        currentPhases: (_mapPhasesFieldAccessMetaInBase31 = mapPhasesFieldAccessMetaInBase3(withProjectMeta.currentPhases)) !== null && _mapPhasesFieldAccessMetaInBase31 !== void 0 ? _mapPhasesFieldAccessMetaInBase31 : withProjectMeta.currentPhases,
        ...withProjectMeta.metrics && {
            metrics: {
                ...withProjectMeta.metrics,
                currentPhases: (_mapPhasesFieldAccessMetaInBase32 = mapPhasesFieldAccessMetaInBase3(withProjectMeta.metrics.currentPhases)) !== null && _mapPhasesFieldAccessMetaInBase32 !== void 0 ? _mapPhasesFieldAccessMetaInBase32 : withProjectMeta.metrics.currentPhases
            }
        }
    };
};
export var VisibilityType = /*#__PURE__*/ function(VisibilityType) {
    VisibilityType["ALL"] = "EVERYONE";
    VisibilityType["INVITED"] = "MEMBERS";
    return VisibilityType;
}({});
export var ProjectStatus = /*#__PURE__*/ function(ProjectStatus) {
    ProjectStatus[ProjectStatus["InProgress"] = 2] = "InProgress";
    ProjectStatus[ProjectStatus["Completed"] = 3] = "Completed";
    ProjectStatus[ProjectStatus["Blocked"] = 4] = "Blocked";
    ProjectStatus[ProjectStatus["Proposed"] = 5] = "Proposed";
    ProjectStatus[ProjectStatus["InPlanning"] = 6] = "InPlanning";
    ProjectStatus[ProjectStatus["ToBeStaffed"] = 7] = "ToBeStaffed";
    ProjectStatus[ProjectStatus["Cancelled"] = 8] = "Cancelled";
    ProjectStatus[ProjectStatus["OnHold"] = 9] = "OnHold";
    return ProjectStatus;
}({});
export var RestrictedType = /*#__PURE__*/ function(RestrictedType) {
    RestrictedType["GROUPS"] = "GROUP";
    RestrictedType["TEAMMEMBERS"] = "MEMBERS";
    return RestrictedType;
}({});
export var InferredProgressLabels = /*#__PURE__*/ function(InferredProgressLabels) {
    InferredProgressLabels["RunningLate"] = "Running Late";
    InferredProgressLabels["OnTrack"] = "On Track";
    InferredProgressLabels["AHeadOfTime"] = "Ahead of time";
    InferredProgressLabels["None"] = "None";
    return InferredProgressLabels;
}({});
export var InferredProgressValue = /*#__PURE__*/ function(InferredProgressValue) {
    InferredProgressValue["RunningLate"] = "RUNNING_LATE";
    InferredProgressValue["OnTrack"] = "ON_TRACK";
    InferredProgressValue["AHeadOfTime"] = "AHEAD_OF_TIME";
    InferredProgressValue["None"] = "NONE";
    return InferredProgressValue;
}({});
export const InferredProgressOptions = (translate)=>[
        {
            label: translate('api.status_updates.inferred_progress.running_late'),
            value: "RUNNING_LATE",
            color: 'red',
            active: true
        },
        {
            label: translate('api.status_updates.inferred_progress.on_track'),
            value: "ON_TRACK",
            color: 'green',
            active: true
        },
        {
            label: translate('api.status_updates.inferred_progress.ahead_of_time'),
            value: "AHEAD_OF_TIME",
            color: 'blue',
            active: true
        },
        {
            label: translate('api.status_updates.inferred_progress.none'),
            value: "NONE",
            color: 'gray',
            active: true
        }
    ];
export var ProjectSourceType = /*#__PURE__*/ function(ProjectSourceType) {
    ProjectSourceType["Template"] = "TEMPLATE";
    return ProjectSourceType;
}({});
export var ProjectCreationStatusState = /*#__PURE__*/ function(ProjectCreationStatusState) {
    ProjectCreationStatusState["InProgress"] = "IN_PROGRESS";
    ProjectCreationStatusState["Completed"] = "COMPLETED";
    ProjectCreationStatusState["Failed"] = "FAILED";
    return ProjectCreationStatusState;
}({});
export var ProjectAccessRequestStatus = /*#__PURE__*/ function(ProjectAccessRequestStatus) {
    ProjectAccessRequestStatus["Pending"] = "PENDING";
    ProjectAccessRequestStatus["Approved"] = "APPROVED";
    ProjectAccessRequestStatus["Rejected"] = "REJECTED";
    return ProjectAccessRequestStatus;
}({});
export class ProjectAPIClient extends HttpClient {
    async getProjectList() {
        return this.get('/projects?lite=true');
    }
    async createProjectToTemplate(projectId, payload) {
        return this.post(`/projects/${projectId}/create-template`, payload);
    }
    async getProjectsLight() {
        const data = await this.get('/projects/light');
        const projectData = data.map(withProjectMetaAndPhaseMeta);
        return updateProjectsPartners(projectData);
    }
    async getProjectsLightForRM() {
        const projectData = await this.get('/projects/lightRM');
        return updateProjectsPartners(projectData);
    }
    async getPaginatedProjectsForRM(queryParams) {
        return this.get(`/projects/rm-light?${queryParams}`);
    }
    async getFilteredPeopleForRM(payload) {
        return this.post('/projects/get-people-projects', payload);
    }
    async getPaginatedPeopleProjectsForRM(payload) {
        return this.post('/projects/get-people-projects', payload);
    }
    async getProjectsMeta() {
        return this.get('/projects/meta');
    }
    async getArchivedProjectList() {
        return this.get('/projects/get-archived');
    }
    async getDeletedProjectList() {
        return this.get('/projects/get-deleted');
    }
    async getProjectDetails(projectId, params = {}) {
        return this.get(`/projects/${projectId}`, {
            params
        }).then(withProjectMetaAndPhaseMeta);
    }
    async getSprints(projectId, params = {}) {
        return this.get(`/projects/${projectId}/sprints`, {
            params
        });
    }
    async getSprintsForProject(projectId, params = {}) {
        return this.get(`/sprints/get-sprints-dropdown?projectId=${projectId}`, {
            params
        });
    }
    async updateProjectPhase(projectId, phaseId, payload, isSync) {
        return this.put(`/projects/${projectId}/phases/${phaseId}${isSync ? `?isSync=${true}` : ''}`, payload).then(mapPhaseFieldAccessMetaInBase3);
    }
    async createProjectPhase(projectId, projectPhase) {
        return this.post(`/projects/${projectId}/phases`, projectPhase).then(mapPhaseFieldAccessMetaInBase3);
    }
    async deleteProjectPhase(projectId, projectPhaseId) {
        return this.delete(`/projects/${projectId}/phases/${projectPhaseId}`);
    }
    async createProject(payload) {
        return this.post('/projects?hasfieldsAccessMeta=false', payload).then(withProjectMetaAndPhaseMeta);
    }
    async createAndInviteProjectMembers(projectId, payload) {
        return this.post(`/projects/${projectId}/invite-members?async=true`, payload);
    }
    async getProjectMembers(projectId) {
        return this.get(`/projects/${projectId}/get-members`);
    }
    async updateProject(projectId, payload) {
        return this.put(`/projects/${projectId}`, payload).then(withProjectMetaAndPhaseMeta);
    }
    async exportProjectAuditLogs(projectId) {
        return this.get(`/projects/${projectId}/project-audit-log/export`);
    }
    async deleteProject(projectId) {
        return this.delete(`/projects/${projectId}`);
    }
    async archiveProject(projectId) {
        return this.post(`/projects/${projectId}/archive`);
    }
    async bulkArchiveProject(payload) {
        return this.put('bulk/projects/archive', payload);
    }
    async unarchiveProject(projectId) {
        return this.post(`/projects/${projectId}/unarchive`);
    }
    async bulkUpdateProject(data) {
        return this.put('/bulk/projects', data);
    }
    async addMembers(projectId, payload) {
        return this.post(`/projects/${projectId}/add-members`, payload.map((p)=>({
                ...p,
                permissionSet: undefined
            })));
    }
    async updateMembers(projectId, payload) {
        return this.put(`/projects/${projectId}/update-members`, payload);
    }
    async removeMembers(projectId, payload) {
        return this.delete(`/projects/${projectId}/remove-members`, {
            data: payload
        });
    }
    async getProjectMembersMeta(projectId) {
        return this.get(`/projects/${projectId}/get-meta`);
    }
    async getProgress(projectId) {
        return this.get(`/projects/${projectId}/progress`);
    }
    async merge(projectId, payload) {
        return this.put(`/projects/${projectId}/merge`, payload);
    }
    async getPreviewAPIKey(projectId) {
        return this.get(`/projects/${projectId}/customer-access`);
    }
    async bulkMergePreview(projectId, payload) {
        return this.post(`/projects/${projectId}/bulk-merge-preview`, payload);
    }
    async bulkMerge(projectId, payload) {
        return this.put(`/projects/${projectId}/bulk-merge`, payload);
    }
    async addTeams(projectId, payload) {
        return this.post(`/projects/${projectId}/add-teams`, payload);
    }
    async removeTeams(projectId, payload) {
        return this.delete(`/projects/${projectId}/remove-teams`, {
            data: payload
        });
    }
    async getAllProjectUsersLite() {
        return this.get('/projects/get-user-teams');
    }
    async getProjectUsersLiteForProject(projectId) {
        return this.get(`/projects/${projectId}/get-user-teams`);
    }
    async addProjectUsersLite(projectId, payload) {
        return this.post(`/projects/${projectId}/add-user-teams`, payload);
    }
    async removeProjectUsersLite(projectId, payload) {
        return this.delete(`/projects/${projectId}/remove-user-teams`, {
            data: payload
        });
    }
    async getPlaceholderResolution([, projectId]) {
        return this.get(`/projects/${projectId}/get-team-sources`);
    }
    async getAllProjectsPlaceholderResolution() {
        return this.get('/projects/get-team-sources');
    }
    gpt({ input }) {
        return this.post('/search', {
            input
        });
    }
    async getProjectFieldValues(projectIds) {
        return this.post('/projects/fields/unique-values', projectIds);
    }
    constructor(...args){
        super(...args), _define_property(this, "getPaginatedProject", async ({ startRow, endRow, filter, sort, groupBy, search, pageSource })=>{
            const { ApiFilter } = await getSimpleSearchFilterModule();
            let url = '/projects/lightV1?';
            const filterAsString = ApiFilter.toQueryStringFormat(filter.criteria);
            if (groupBy) {
                url += `&groupBy=${groupBy}&`;
            }
            if (filter.criteria.length) {
                url += `&${filterAsString}&match=${filter.type}&`;
            }
            if (search) {
                url += `searchValue=${search}&`;
            }
            if (sort) {
                url += `sort=${sort}&`;
            }
            if (pageSource) {
                url += `pageSource=${pageSource}&`;
            }
            url += `offset=${startRow}&limit=${endRow - startRow}`;
            return this.get(url).then((response)=>({
                    ...response,
                    data: response.data.map(withProjectMetaAndPhaseMeta)
                }));
        }), _define_property(this, "postPaginatedProject", async ({ startRow, endRow, filter, sort, groupBy, search, pageSource })=>{
            let url = '/projects/lightV1?';
            if (groupBy) {
                url += `&groupBy=${groupBy}&`;
            }
            if (search) {
                url += `searchValue=${search}&`;
            }
            if (sort) {
                url += `sort=${sort}&`;
            }
            if (pageSource) {
                url += `pageSource=${pageSource}&`;
            }
            url += `offset=${startRow}&limit=${endRow - startRow}`;
            return this.post(url, {
                filter
            }).then((response)=>({
                    ...response,
                    data: response.data.map(withProjectMetaAndPhaseMeta)
                }));
        }), _define_property(this, "getProjectsByCustomer", async (companyId)=>{
            return this.get(`/projects/lightV1?project*customer.value=${companyId}`).then((response)=>response.data.map(withProjectMetaAndPhaseMeta));
        }), _define_property(this, "getProjectGroupMeta", async ({ filter, groupName, search })=>{
            const { ApiFilter } = await getSimpleSearchFilterModule();
            let url = `projects/lightV1/group?groupBy=${groupName}`;
            const filterAsString = ApiFilter.toQueryStringFormat(filter.criteria);
            if (search) {
                url += `&searchValue=${search}`;
            }
            if (filter.criteria.length) {
                url += `&${filterAsString}&match=${filter.type}&`;
            }
            return this.get(url);
        }), _define_property(this, "postProjectGroupMeta", async ({ filter, groupName, search })=>{
            var _filter_nativeFields;
            let url = `projects/lightV1/group?groupBy=${groupName}`;
            if ((_filter_nativeFields = filter.nativeFields) === null || _filter_nativeFields === void 0 ? void 0 : _filter_nativeFields.length) {
                url += `&match=${filter.match}`;
            }
            if (search) {
                url += `&searchValue=${search}`;
            }
            return this.post(url, filter);
        }), _define_property(this, "getMembers", async (projectId)=>{
            if (projectId == null || Number.isNaN(projectId)) {
                return Promise.resolve({
                    members: []
                });
            }
            return this.get(`/projects/${projectId}/members`);
        }), _define_property(this, "exportAsCSV", async (filters, match, columnOrder)=>{
            const { ApiFilter } = await getSimpleSearchFilterModule();
            // const filterString = ApiFilter.toQueryStringFormat(filters);
            // const filterObject = ApiFilter.convertQueryStringToObject(filterString);
            // const request: ExportRequest = {
            //   match: filters.length ? match : QueryCombinerType.All,
            //   ...filterObject,
            // };
            // const data: ExportPayload = {
            //   statusType: ExportStatusType.ProjectExport,
            //   statusMeta: { request },
            // };
            return this.post(`reports/project-list/export?${ApiFilter.toQueryStringFormat(filters)}&${stringify({
                match: filters.length ? match : null
            }, {
                skipNull: true
            })}`, {
                columnOrder
            }).then((response)=>response);
        }), _define_property(this, "getProjectBaselines", (projectId)=>this.get(`/projects/${projectId}/baseline`)), _define_property(this, "createProjectBaseline", (projectId, payload)=>this.post(`/projects/${projectId}/baseline`, payload)), _define_property(this, "updateProjectBaseline", (projectId, baselineId, payload)=>this.put(`/projects/${projectId}/baseline/${baselineId}`, payload)), _define_property(this, "deleteProjectBaseline", (projectId, baselineId)=>this.delete(`/projects/${projectId}/baseline/${baselineId}`)), _define_property(this, "addPartners", (projectId, partnerCompanyIds)=>this.post(`/projects/${projectId}/add-partner`, partnerCompanyIds.map((id)=>({
                    companyId: id
                })))), _define_property(this, "removePartners", (projectId, partnerCompanyIds)=>this.post(`/projects/${projectId}/remove-partner`, partnerCompanyIds.map((id)=>({
                    companyId: id
                })))), _define_property(this, "bulkShiftDates", (projectId, payload)=>this.post(`/projects/${projectId}/bulk-shift-dates`, payload)), _define_property(this, "paginateAndFilter", async ({ startRow, endRow, filter, sort, filterType })=>{
            const { ApiGroupFilter } = await getSimpleSearchFilterModule();
            let url = '/projects/lightV1?';
            const filterAsString = ApiGroupFilter.toQueryStringFormatForGroups(filter);
            if (filter.length) {
                url += `${filterAsString}&match=${filterType}&`;
            }
            if (sort) {
                url += `sort=${sort}`;
            }
            url += `&offset=${startRow}&limit=${endRow - startRow}`;
            return this.get(url).then((response)=>({
                    ...response,
                    data: response.data.map(withProjectMetaAndPhaseMeta)
                }));
        }), _define_property(this, "getAllProjectCurrentPhases", ()=>this.get('/projects/current-phases').then((phases)=>{
                var _mapPhasesFieldAccessMetaInBase3;
                return (_mapPhasesFieldAccessMetaInBase3 = mapPhasesFieldAccessMetaInBase3(phases)) !== null && _mapPhasesFieldAccessMetaInBase3 !== void 0 ? _mapPhasesFieldAccessMetaInBase3 : phases;
            })), _define_property(this, "getAllProjectCurrentPhasesV2", ({ search: searchValue, limit, offset })=>this.get('/projects/current-phases', {
                params: {
                    searchValue,
                    offset,
                    limit
                }
            }).then((res)=>{
                var _mapPhasesFieldAccessMetaInBase3;
                return {
                    ...res,
                    data: (_mapPhasesFieldAccessMetaInBase3 = mapPhasesFieldAccessMetaInBase3(res.data)) !== null && _mapPhasesFieldAccessMetaInBase3 !== void 0 ? _mapPhasesFieldAccessMetaInBase3 : res.data
                };
            })), _define_property(this, "getVariablesData", (projectId)=>this.get(`/variables/${projectId}`)), _define_property(this, "getProjectFinancialsData", (url)=>this.get(url)), // Keeping two separate APIs below in order to handle Types
        _define_property(this, "getProjectFinancials", async ({ projectId, includeSubscriptionMeta, subscriptionPeriodId, queryParams, budgetId })=>this.getProjectFinancialsData(`/projects/${projectId}/financials${includeSubscriptionMeta ? '?includeSubscriptionMeta=true' : subscriptionPeriodId != null ? `?periodId=${subscriptionPeriodId}` : ''}${budgetId != null ? `${includeSubscriptionMeta || subscriptionPeriodId != null ? '&' : '?'}${stringify({
                projectFinancialsBudgetId: budgetId
            }, {
                skipNull: true
            })}` : ''}${queryParams != null ? `&${stringify({
                groupBy: queryParams.groupBy,
                zoomLevel: queryParams.zoomLevel,
                tabType: queryParams.tabType
            }, {
                skipNull: true
            })}` : ''}`)), _define_property(this, "getProjectFinancialsWithQuery", async (projectId, queryParams, budgetId, subscriptionPeriodId)=>this.get(`/projects/${projectId}/financials?${budgetId != null ? `${stringify({
                projectFinancialsBudgetId: budgetId
            }, {
                skipNull: true
            })}&` : ''}${stringify({
                groupBy: queryParams.groupBy,
                zoomLevel: queryParams.zoomLevel,
                tabType: queryParams.tabType
            }, {
                skipNull: true
            })}${subscriptionPeriodId != null ? `&periodId=${subscriptionPeriodId}` : ''}`)), _define_property(this, "getProjectPermissionsForCurrentUser", (projectId)=>this.get(`/projects/${projectId}/permissions`)), /**
   *
   * @param projectId
   * @deprecated This has been deprecated in favour of V2 apis supporting multibudget financials
   * @returns
   */ _define_property(this, "getProjectBudgetSettings", async (projectId)=>this.get(`projects/${projectId}/financials/settings`)), _define_property(this, "getProjectUserTeamsCostRates", async (projectId)=>this.get(`projects/${projectId}/cost-rates`)), /**
   *
   * @param projectId
   * @param payload
   * @description Use updateProjectBudgetSettingsV2 to update any budget related details.
   * @returns
   */ _define_property(this, "updateProjectBudgetSettings", async (projectId, payload, resetRateOverrides = false)=>this.put(`projects/${projectId}/financials/settings?resetRateOverrides=${resetRateOverrides}`, payload)), _define_property(this, "updateProjectGeneralSettingsV2", async (projectId, payload)=>this.put(`projects/${projectId}/financialsV2/settings`, payload)), _define_property(this, "updateProjectCostRates", async (projectId, backDate, payload, resetRateOverrides = false)=>this.put(`projects/${projectId}/cost-rates?backdate=${backDate}&resetRateOverrides=${resetRateOverrides}`, payload)), _define_property(this, "getProjectRateCardVersion", (projectId, rateCardVersionId)=>this.get(`projects/${projectId}/rate-cards/versions/${rateCardVersionId}`)), _define_property(this, "shiftTasks", async (projectId, payload)=>this.put(`projects/${projectId}/rearrange-phases-and-tasks`, {
                ...payload,
                useEntityOrder: true
            })), _define_property(this, "reorderPhases", async (projectId, payload)=>this.put(`projects/${projectId}/reorder-phases`, payload)), _define_property(this, "getDependenciesMap", async (projectId)=>this.get(`projects/${projectId}/dependency-map`)), _define_property(this, "getPhasesForAProject", async (projectId)=>this.get(`projects/${projectId}/project-phases`)), _define_property(this, "getProjectStatusMapping", async (projectIds)=>this.get(`projects/status-mapping?projectIds=${projectIds}`)), _define_property(this, "getProjectFinancialContractMapping", async ()=>this.get('projects/financial-contract-mapping')), _define_property(this, "getProjectPartnerMapping", async (projectIds)=>{
            return this.post('projects/partnersV2', projectIds);
        }), _define_property(this, "getProjectCreationStatus", async (projectId)=>this.get(`projects/${projectId}/status`)), _define_property(this, "updateAllowedDomains", async (projectId, payload)=>{
            return this.put(`/projects/${projectId}/allowed-domains`, payload);
        }), _define_property(this, "getShareUrlForProject", async (projectId, payload)=>{
            return this.post(`projects/${projectId}/customer-portal-share-url`, payload);
        }), _define_property(this, "addUsersFromShareUrl", (payload)=>{
            return this.post('/projects/add-users-from-share-url', payload);
        }), _define_property(this, "getProjectAccessRequestedUsers", (projectId)=>this.get(`projects/${projectId}/access-requested-users`)), _define_property(this, "approveProjectAccess", (projectId, payload)=>this.post(`projects/${projectId}/requested-users/approve-access`, payload)), _define_property(this, "rejectProjectAccess", (projectId, payload)=>this.post(`projects/${projectId}/requested-users/reject-access`, payload)), _define_property(this, "getCountOfTasksInProjectFromView", (projectId, viewId)=>this.get(`projects/${projectId}/view/${viewId}/count`)), _define_property(this, "getfTasksInProjectFromView", (projectId, viewId)=>this.get(`projects/${projectId}/view/${viewId}/tasks`)), /** V2 APIs for Multiline Budgets */ _define_property(this, "getProjectBudgetSettingsV2", async (projectId)=>this.get(`projects/${projectId}/financial-budgets/settings`)), _define_property(this, "createProjectBudgetSettingsV2", async (projectId, payload)=>this.post(`/projects/${projectId}/financial-budgets/settings`, payload)), _define_property(this, "updateProjectBudgetSettingsV2", async (projectId, projectFinancialBudgetId, payload, resetRateOverrides = false)=>this.put(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/settings?resetRateOverrides=${resetRateOverrides}`, payload)), /** Patch native/custom budget fields without a full settings/versioned update. */ _define_property(this, "updateProjectFinancialBudgetFields", async (projectId, projectFinancialBudgetId, payload)=>this.put(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/fields`, payload)), _define_property(this, "deleteProjectBudget", async (payload)=>{
            const { projectId, projectFinancialsBudgetId, ...optionalFields } = payload;
            return this.delete(`/projects/${projectId}/financial-budgets/${projectFinancialsBudgetId}/settings`, {
                data: optionalFields
            });
        }), _define_property(this, "markBudgetAsDefault", async (projectId, projectFinancialBudgetId)=>this.put(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/default`, undefined, // eslint-disable-next-line @typescript-eslint/naming-convention
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            })), _define_property(this, "getMemberExclusionsForBudget", async (projectId, projectFinancialBudgetId)=>this.get(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/member-exclusions`)), _define_property(this, "updateFinancialBudgetMembers", async (projectId, projectFinancialBudgetId, payload)=>this.put(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/members`, payload)), _define_property(this, "deleteBudgetMember", async (projectId, projectFinancialBudgetId, payload)=>this.delete(`/projects/${projectId}/financial-budgets/${projectFinancialBudgetId}/members`, {
                data: payload
            })), _define_property(this, "getFinancialBudgetAuditLogs", async (projectId, budgetId, metaName)=>this.get(`/projects/${projectId}/financial-budgets/${budgetId}/audit`, {
                params: metaName ? {
                    metaName
                } : undefined
            })), _define_property(this, "getFinancialBudgetsLite", async (projectIds)=>{
            const projectIdsString = projectIds.join(',');
            return this.get(`/financial-budgets/lite?projectIds=${projectIdsString}`);
        }), _define_property(this, "getMemberExclusionsForProject", async (projectId)=>this.get(`/projects/${projectId}/budget-member-exclusions`)), _define_property(this, "addMembersToBudget", async (payload)=>this.put('/financial-budgets/members/bulk-action', payload)), _define_property(this, "getPaginatedBudgets", async ({ startRow, endRow, filter, sort, search, projectId, groupBy })=>{
            var _filter_criteria;
            let filterString = '';
            if (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : _filter_criteria.length) {
                try {
                    // ApiGroupFilter / FieldFilter live in the lazily-loaded
                    // simple-search-filter chunk (kept out of app.js by the perf work in
                    // #18175). Resolve them through the module accessor — a top-level
                    // value import here would drag the tasks filter stack back into the
                    // entry chunk, and referencing them bare crashes at runtime
                    // (ReferenceError) since only type imports exist in this file.
                    // FieldFilter.isValid strips unfinished rows (e.g. date "Anything" /
                    // IsAny) the same way RM and source-type group serializers do — those
                    // serialize as `*.value=undefined` and 500 on lightV1.
                    const { ApiGroupFilter, FieldFilter } = await getSimpleSearchFilterModule();
                    filterString = ApiGroupFilter.toQueryStringFormatForGroups(filter.criteria.filter((c)=>(c === null || c === void 0 ? void 0 : c.field) != null && FieldFilter.isValid(c)).map((c)=>{
                        var _c_field;
                        return {
                            id: (_c_field = c.field) === null || _c_field === void 0 ? void 0 : _c_field.fieldName,
                            criteria: c
                        };
                    }));
                } catch (error) {
                    // A criterion the serializer can't format (e.g. one with an
                    // unresolved operation type hits `unreachable`) must not reject this
                    // request before the HTTP call — that latches the grid's server-side
                    // row model into a permanent "ERR" state. Log and fall back to the
                    // unfiltered query; a completed criterion re-fires the filtered one.
                    logger.error('Failed to serialize budget list filter', {
                        error,
                        projectId
                    });
                }
            }
            const url = `/financial-budgets/lightV1?${stringify({
                offset: startRow,
                limit: endRow - startRow,
                match: filter === null || filter === void 0 ? void 0 : filter.type,
                searchValue: search,
                sort,
                groupBy,
                projectId
            }, {
                skipNull: true,
                skipEmptyString: true
            })}`;
            return this.get(`${url}${filterString ? `&${filterString}` : ''}`);
        }), // Kicks off an async CSV export of the project budget list, mirroring
        // InvoicesAPI.exportAsCSV. Returns ExportMetaData (COMPLETED with a downloadUrl
        // for small exports, PROCESSING for large ones handled out of band).
        _define_property(this, "exportBudgetsAsCSV", async (columnOrder, filter, projectId)=>{
            var _filter_criteria;
            // Same lazy resolution as getPaginatedBudgets — only type imports of
            // these names exist at this file's top level. Unlike the list query, a
            // serialization failure here must reject (surfacing the export error)
            // rather than silently exporting unfiltered data.
            let filterString = '';
            if (filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : _filter_criteria.length) {
                const { ApiGroupFilter, FieldFilter } = await getSimpleSearchFilterModule();
                filterString = ApiGroupFilter.toQueryStringFormatForGroups(filter.criteria.filter((c)=>(c === null || c === void 0 ? void 0 : c.field) != null && FieldFilter.isValid(c)).map((c)=>{
                    var _c_field;
                    return {
                        id: (_c_field = c.field) === null || _c_field === void 0 ? void 0 : _c_field.fieldName,
                        criteria: c
                    };
                }));
            }
            const url = `/financial-budgets/export?${stringify({
                match: filter === null || filter === void 0 ? void 0 : filter.type,
                projectId
            }, {
                skipNull: true,
                skipEmptyString: true
            })}${filterString ? `&${filterString}` : ''}`;
            return this.post(url, {
                columnOrder
            });
        });
    }
}
_ts_decorate([
    RliPreHook({
        event: ProjectEvents.ProjectCreate,
        dataGetter: (data)=>({
                project: data
            })
    })
], ProjectAPIClient.prototype, "createProject", null);
_ts_decorate([
    RliPreHook({
        event: ProjectEvents.ProjectUpdate,
        dataGetter: (projectId, data)=>({
                projectId,
                project: data
            })
    })
], ProjectAPIClient.prototype, "updateProject", null);
export const ProjectAPI = new ProjectAPIClient();
export * from './types';
// Light tab metadata only — heavy assets (projectTabIconMap, PROJECT_TABS,
// createFontAwesomeIcon) live in ./tabs; deep-path them where needed so the
// shell barrel doesn't drag FontAwesome and the icon map into app.js.
export * from './tab-keys';
